import React, { useState, useEffect } from "react";
import Navbar from "../components/main_page/Navbar";
import emailjs from "emailjs-com";

function Contact() {
  const [status, setStatus] = useState("pending");

  //   useEffect((status)=>{

  //   })
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_xvmd8oa",
        "template_saufw78",
        e.target,
        "5xDfzNkFasqq8SpEE"
      )
      .then(
        (result) => {
          setStatus("success");
          console.log(result.text);
        },
        (error) => {
          setStatus("error");
          console.log(error.text);
        }
      );
    e.target.reset();
  }

  return (
    <div className="bg-slate-50 h-screen">
      <Navbar focus="contact" />
      <div className="pt-40">
        <div className="w-[90%] md:w-96 bg-white md:max-w-full mx-auto">
          <div className="p-6 border border-gray-300 sm:rounded-md">
            <form onSubmit={sendEmail}>
              <label className="block mb-6">
                <span className="text-gray-700">Your name</span>
                <input
                  required
                  type="text"
                  name="from_name"
                  className="block py-2 px-4 w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  placeholder="John Doe"
                />
              </label>
              <label className="block mb-6">
                <span className="text-gray-700">Email address</span>
                <input
                  name="email"
                  type="email"
                  className="
            block
            py-2 px-4
            w-full
            mt-1
            border-gray-300
            rounded-md
            shadow-sm
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
          "
                  placeholder="joe.doe@example.com"
                  required
                />
              </label>
              <label className="block mb-6">
                <span className="text-gray-700">Message</span>
                <textarea
                  required
                  name="message"
                  className="
            block
            w-full
            py-2 px-4
            mt-1
            border-gray-300
            rounded-md
            shadow-sm
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
          "
                  rows="3"
                  placeholder="Tell me something"
                ></textarea>
              </label>
              <div className="mb-6">
                <button
                  type="submit"
                  className="w-full mt-3 bg-cool-300 hover:bg-cool-400 transition text-white py-2 rounded-md"
                >
                  Contact Me
                </button>

                <div
                  className={`w-full text-center p-1 ${
                    status === "success" ? "block" : "hidden"
                  } mt-2  bg-green-50 border border-green-800 text-green-800 text-xs`}
                >
                  Email successfully sent
                </div>

                <div
                  className={`w-full text-center p-1 ${
                    status === "error" ? "block" : "hidden"
                  } mt-2  bg-red-50 border border-red-800 text-red-800 text-xs`}
                >
                  Email could not be sent
                </div>
              </div>
              <div>
                <div className="mt-2 text-gray-700 text-right text-xs">
                  Thank you 😃
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
